import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import { Shell } from "./components/Shell";
import { BoardPage } from "./pages/BoardPage";
import { LoginPage } from "./pages/LoginPage";
import { PeoplePage } from "./pages/PeoplePage";
import { PassportRecordPage } from "./pages/PassportRecordPage";
import { PassportsPage } from "./pages/PassportsPage";
import { SettingsPage } from "./pages/SettingsPage";
import { TimelinePage } from "./pages/TimelinePage";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { token } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/board" replace />;
  return children;
}

export default function App() {
  const { token } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={token ? <Navigate to="/main" replace /> : <LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Shell />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/main" replace />} />
        <Route path="main" element={<PassportsPage />} />
        <Route path="board" element={<BoardPage />} />
        <Route path="timeline" element={<TimelinePage />} />
        <Route path="passports" element={<Navigate to="/main" replace />} />
        <Route path="passports/:passportId" element={<PassportRecordPage />} />
        <Route
          path="people"
          element={
            <RequireAdmin>
              <PeoplePage />
            </RequireAdmin>
          }
        />
        <Route
          path="settings"
          element={
            <RequireAdmin>
              <SettingsPage />
            </RequireAdmin>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to={token ? "/main" : "/login"} replace />} />
    </Routes>
  );
}
